// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3couf","inputWrap":"CustomTip_inputWrap__2N0QC"};